import { defineMessages } from 'react-intl';

export default defineMessages({
  cardTitle: {
    id: 'homeCompilationSelectionDialog.cardTitle',
    defaultMessage:
      'Per compilare il questionario MiFID è necessario che il tuo Consulente Finanziario sia presente.',
  },
  cardSecondTitle: {
    id: 'homeCompilationSelectionDialog.cardSecondTitle',
    defaultMessage: 'In quale modalità intendi proseguire?',
  },
  radioRightLabel: {
    id: 'homeCompilationSelectionDialog.radioRightLabel',
    defaultMessage: 'WEB COLLABORATION',
  },
  radioLeftLabel: {
    id: 'homeCompilationSelectionDialog.radioLeftLabel',
    defaultMessage: 'IN PRESENZA',
  },
  radioRightDescriptionLabel: {
    id: 'homeCompilationSelectionDialog.radioRightDescriptionLabel',
    defaultMessage:
      'Il tuo Consulente Finanziario ti supporterà nella compilazione del questionario MiFID in una sessione online direttamente dal tuo smartphone o dal tuo PC ovunque ti trovi',
  },
  radioLeftDescriptionLabel: {
    id: 'homeCompilationSelectionDialog.radioLeftDescriptionLabel',
    defaultMessage:
      'Il tuo Consulente finanziario ti supporterà nella compilazione del questionario MiIFID direttamente di persona',
  },
  ctaLabel: {
    id: 'homeCompilationSelectionDialog.ctaLabel',
    defaultMessage: 'INVIA RICHIESTA',
  },
  successToastTitle: {
    id: 'homeCompilationSelectionDialog.successToastTitle',
    defaultMessage: 'Richiesta inviata',
  },
  successToastTextWebCollaboration: {
    id: 'homeCompilationSelectionDialog.successToastTextWebCollaboration',
    defaultMessage:
      'Gentile {customerName},\nAbbiamo inviato la richiesta al tuo Consulente Finanziario.\nRiceverai al più presto un\'email per svolgere la compilazione del questionario MiFID contenente l\'indicazione di data e ora dell\'appuntamento. Una volta giunto il momento dell\'appuntamento dovrai avviare la videochiamata direttamente dal tuo MyAzimut cliccando “Vai al questionario”.\nGrazie',
  },
  successToastTextPresence: {
    id: 'homeCompilationSelectionDialog.successToastTextPresence',
    defaultMessage:
      'Gentile {customerName},\nAbbiamo inviato la richiesta al tuo Consulente Finanziario.\nVerrai contattato al più presto per concordare un appuntamento in presenza per la compilazione del Questionario MiFID.\nGrazie.',
  },
  cardTitleWithMeetingDate: {
    id: 'homeCompilationSelectionDialog.cardTitleWithMeetingDate',
    defaultMessage:
      'Hai già un appuntamento fissato per giorno {date}, se desideri fissare un nuovo appuntamento (con la medesima modalità) ti invitiamo a contattare il tuo consulente finanziario. Se desideri invece cambiare modalità, potrai farlo qui in seguito.',
  },
});
